export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 18c4.96 0 9-4.04 9-9s-4.04-9-9-9-9 4.04-9 9 4.04 9 9 9zM9 2c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7zm0 12a1.25 1.25 0 100-2.5A1.25 1.25 0 009 14zM8 4h2v6.5H8V4z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};